import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { Product } from '../types';
import { getProducts } from '../services/api';
import { DEMO_PRODUCTS } from '../data/products';

const Shop: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState<Product[]>(DEMO_PRODUCTS);
  const [searchTerm, setSearchTerm] = useState('');

  const activeCategory = searchParams.get('category') || '';
  const sortBy = searchParams.get('sort') || '';

  useEffect(() => {
    const params: Record<string, string> = {};
    if (activeCategory) params.category = activeCategory;
    if (sortBy) params.ordering = sortBy;
    if (searchTerm) params.search = searchTerm;

    getProducts(params)
      .then(res => {
        if (res.data.results && res.data.results.length > 0) {
          setProducts(res.data.results);
        }
      })
      .catch(() => {});
  }, [activeCategory, sortBy, searchTerm]);

  let filteredProducts = activeCategory
    ? products.filter(p => p.category_name.toLowerCase() === activeCategory.toLowerCase())
    : products;

  if (searchTerm) {
    const term = searchTerm.toLowerCase();
    filteredProducts = filteredProducts.filter(
      p => p.name.toLowerCase().includes(term) || p.description.toLowerCase().includes(term)
    );
  }

  if (sortBy) {
    filteredProducts = [...filteredProducts].sort((a, b) => {
      if (sortBy === 'price') return parseFloat(a.price) - parseFloat(b.price);
      if (sortBy === '-price') return parseFloat(b.price) - parseFloat(a.price);
      if (sortBy === 'name') return a.name.localeCompare(b.name);
      return 0;
    });
  }

  return (
    <div className="shop-page">
      <div className="shop-header">
        <h1>{activeCategory ? activeCategory.charAt(0).toUpperCase() + activeCategory.slice(1) : 'All Pieces'}</h1>
        <p>{filteredProducts.length} {filteredProducts.length === 1 ? 'piece' : 'pieces'}</p>
      </div>

      <div className="shop-controls">
        <div className="shop-filters">
          <button
            className={`filter-btn ${!activeCategory ? 'active' : ''}`}
            onClick={() => { setSearchParams({}); }}
          >
            All
          </button>
          {['Dresses', 'Sets', 'Gowns'].map(cat => (
            <button
              key={cat}
              className={`filter-btn ${activeCategory === cat.toLowerCase() ? 'active' : ''}`}
              onClick={() => setSearchParams({ category: cat.toLowerCase() })}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="shop-search">
          <input
            type="text"
            placeholder="Search pieces..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>

        <select
          className="shop-sort"
          value={sortBy}
          onChange={e => {
            const params: Record<string, string> = {};
            if (activeCategory) params.category = activeCategory;
            if (e.target.value) params.sort = e.target.value;
            setSearchParams(params);
          }}
        >
          <option value="">Sort by</option>
          <option value="price">Price: Low to High</option>
          <option value="-price">Price: High to Low</option>
          <option value="name">Name: A-Z</option>
        </select>
      </div>

      <div className="product-grid">
        {filteredProducts.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>

      {filteredProducts.length === 0 && (
        <div className="empty-state">
          <h3>No pieces found</h3>
          <p>Try adjusting your filters or search term.</p>
        </div>
      )}
    </div>
  );
};

export default Shop;
